module.exports = __webpack_public_path__ + "static/media/programa_campo_esquema_en.1e14d188.jpg";